
import { login, loginByIpSms, logout, getInfo, appLogin, getUserInfoDetail, getSystemSetting } from '@/util/api'
import { getToken, setToken, removeToken } from '@/util/auth'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: localStorage.getItem('userInfo') ? [JSON.parse(localStorage.getItem('userInfo')).roleCode] : [],
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : { permissionCodes: [] },
  userMenuTree: [],
  fapiao: {},
  tabchoose: '0',
  choosefapiao: {}
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USEINFO: (state, userInfo) => {
    state.userInfo = userInfo;
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  setUserTree: (state, userMenuTree) => {
    state.userMenuTree = userMenuTree
  },
  setFapiao: (state, fapiao) => {
    state.fapiao = fapiao
  },
  setTabChoose: (state, tabchoose) => {
    state.tabchoose = tabchoose
  },
  setChooseFapiao: (state, choose) => {
    state.choosefapiao = choose
  },
}

function getPhoneBindingSetting() {
  return getSystemSetting(3).then(response => JSON.parse(response.data.settings).mustBindPhone === true)
}

async function saveLoginState(commit, data) {
  commit('SET_TOKEN', data.token)
  setToken(data.token)
  try {
    data.mustBindPhone = await getPhoneBindingSetting()
    data.loginSysUserVo.mustBindPhone = data.mustBindPhone
    commit('SET_USEINFO', data.loginSysUserVo)
    commit('SET_ROLES', [data.roleCode])
    return data
  } catch (error) {
    commit('SET_TOKEN', '')
    commit('SET_USEINFO', {})
    commit('SET_ROLES', [])
    removeToken()
    throw error
  }
}

function clearQRCodeOrderContext() {
  sessionStorage.removeItem("agentUserId")
}

const actions = {
  /**
   * 执行账号密码登录，并将 4002 交给页面进入短信验证。
   */
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(async response => {
        if (response.code === 4002) {
          resolve(response)
          return
        }
        const { data } = response
        await saveLoginState(commit, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 使用密码、手机号和短信验证码完成 IP 异常登录。
   * @Author: zero
   */
  loginByIpSms({ commit }, userInfo) {
    const { username, phone, password, verifyCode, verifyUniqueId } = userInfo
    return new Promise((resolve, reject) => {
      loginByIpSms({
        username: username.trim(),
        phone: phone.trim(),
        password,
        verifyCode: verifyCode.trim(),
        verifyUniqueId
      }).then(async response => {
        const { data } = response
        await saveLoginState(commit, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  appPlusLogin({ commit }, params) {
    return new Promise((resolve, reject) => {
      appLogin(params).then(async response => {
        const { data } = response
        await saveLoginState(commit, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  setUserInfo: ({ commit }, data) => saveLoginState(commit, data),
  loadPhoneBindingSetting({ commit, state }) {
    return getPhoneBindingSetting().then(mustBindPhone => {
      commit('SET_USEINFO', { ...state.userInfo, mustBindPhone })
      return mustBindPhone
    })
  },
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserInfoDetail(state.userInfo.id).then(response => {
        const { data } = response

        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const { nickname, head } = data
        // const roles = [roleCode]
        // // roles must be a non-empty array
        // if (!roles || roles.length <= 0) {
        //   reject('getInfo: roles must be a non-null array!')
        // }

        // commit('SET_ROLES', roles)
        data.mustBindPhone = state.userInfo.mustBindPhone;
        commit('SET_NAME', nickname)
        commit('SET_AVATAR', head)
        commit('SET_USEINFO', Object.assign({}, state.userInfo, data));
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        clearQRCodeOrderContext()
        removeToken()
        window.location.reload();
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  resetToken({ commit }, { clearQRCodeContext = false } = {}) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      commit('SET_USEINFO', {})
      if (clearQRCodeContext) clearQRCodeOrderContext()
      removeToken()
      resolve()
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js